import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Server } from 'lucide-react';

export default function InfrastructureMonitor() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">Infrastructure Monitor</h1>
        <p className="text-[#8A93A6]">System health, uptime, and infrastructure status</p>
      </div>
      <Card className="glass">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2 text-white">
            <Server className="h-5 w-5 text-cyan-500" />
            System Status
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-[#8A93A6]">Infrastructure health monitoring, service status, and system metrics will be displayed here.</p>
        </CardContent>
      </Card>
    </div>
  );
}
